module.exports = __webpack_public_path__ + "img/image5.6ac4a161.png";